import React from 'react';
import { Field, useFormikContext } from 'formik';

import { CheckboxUI, FormErrorUI, FormLabelUI, InputUI, SelectUI } from '../Interface';

export const ITEM_TYPE_PROPERTY_DATA_TYPES = [
  { value: 'NUMBER', label: 'Egész szám' },
  { value: 'DECIMAL', label: 'Törtszám' },
  { value: 'COMBO', label: 'Szöveg (választólista)' },
  { value: 'TEXT', label: 'Tetszőleges érték' },
];

const ItemTypePropertyFields = ({ viewField }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();

  return (
    <div className="grid grid-cols-4 gap-x-4 gap-y-2 mx-4 mb-5">
      <div className="col-span-4 md:col-span-2">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Név" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.name) }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          name="dataType"
          component={SelectUI}
          fullWidth
          option={ITEM_TYPE_PROPERTY_DATA_TYPES}
          value={values.dataType ?? ''}
          variant="standard"
          onChange={(e) => {
            const value = e.target.value ?? null;
            setFieldValue('dataType', value).then(() => {
              validateField('dataType');
            });
          }}
          label={<FormLabelUI text="Adattípus" />}
          helperText={<FormErrorUI message={errors.dataType} />}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.dataType) }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="text"
          name="externalCode"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Külső azonosító" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.externalCode} />}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.externalCode) }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          name="active"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Aktív" />}
          disabled={viewField}
          checked={values.active === true}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          name="mandatory"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Kötelező" />}
          disabled={viewField}
          checked={values.mandatory === true}
        />
      </div>
    </div>
  );
};

export default ItemTypePropertyFields;
